<script setup lang="ts">
import IconInformation from '~icons/mdi/information-outline'

const userStore = useUserStore()
const localePath = useLocalePath()
</script>

<template>
  <div v-if="userStore.isPharmacyBannerVisible" class="pharmacy-banner-wrapper py-2" data-test-id="pharmacy-banner">
    <v-container class="d-flex align-center pa-0">
      <v-icon
        :icon="IconInformation"
        color="#FFA600"
        class="mr-3"
        size="32"
      />
      <span class="pharmacy-banner-text text-body-1 mr-4">
        {{ $t(userStore.hasOutdatedPharmacyCertificate ? 'layout.pharmacyBanner.outdatedText' : 'layout.pharmacyBanner.text') }}
      </span>
      <v-btn
        color="#FFA600"
        variant="flat"
        size="small"
        rounded="lg"
        class="text-white font-weight-bold text-body-2 ml-4"
        data-test-id="pharmacy-banner-action"
        :to="localePath('/account/profile')"
        data-nav-id="pharmacy_banner_cta"
      >
        {{ $t(userStore.hasOutdatedPharmacyCertificate ? 'layout.pharmacyBanner.outdatedAction' : 'layout.pharmacyBanner.action') }}
      </v-btn>
    </v-container>
  </div>
</template>

<style scoped>
.pharmacy-banner-wrapper {
  background-color: #FFEED6;
  position: sticky;
  top: 136px;
  z-index: 99;
}
.pharmacy-banner-text {
  color: #FFA600;
}
</style>
